import { AppStateSlice } from '$tablet-app/src/app/stores/app_state';
import { addOrReplaceRecord } from '$tablet-app/src/app/utils/arrays';
import { removeRecordByID } from '$tablet-app/src/app/utils/records';
import { ChatContextStore } from './types';

export const createChatContextStore: AppStateSlice<ChatContextStore> = (
  set,
  get
) => ({
  chat_context_modifiers: [],
  modifyChatContext(modifier) {
    set(({ chat_context_modifiers }) => ({
      chat_context_modifiers: addOrReplaceRecord(
        chat_context_modifiers,
        modifier
      ),
    }));
  },
  removeChatContextModifer(id: string) {
    set(({ chat_context_modifiers }) => ({
      chat_context_modifiers: removeRecordByID(chat_context_modifiers, id),
    }));
  },
  evaluateChatContext: (context?: object) => {
    return {
      ...get().chat_context_modifiers.reduce<object>(
        (acc, curr) => ({ ...acc, ...curr.data }),
        {}
      ),
      ...context,
    };
  },
});
